import { render } from "./RiWidgetResource.vue?vue&type=template&id=1b523b02"
import script from "./RiWidgetResource.vue?vue&type=script&lang=js"
export * from "./RiWidgetResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiWidgetResource.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b523b02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b523b02', __exports__)) {
    api.reload('1b523b02', __exports__)
  }
  
  module.hot.accept("./RiWidgetResource.vue?vue&type=template&id=1b523b02", () => {
    api.rerender('1b523b02', render)
  })

}


export default __exports__